import { useEffect } from "react";

let ldCounter = 0;

// Mantém no sameAs apenas URLs absolutas e válidas de perfis oficiais (https://...).
// Remove vazios, nomes de usuário isolados e links de exemplo/placeholder.
export function validSameAs(urls) {
  return (urls || []).filter((u) => {
    if (typeof u !== "string") return false;
    const v = u.trim();
    if (!v.startsWith("https://")) return false;
    try {
      const parsed = new URL(v);
      return Boolean(parsed.hostname) && !parsed.hostname.includes("example.");
    } catch {
      return false;
    }
  });
}

export default function Seo({ title, description, canonicalPath = "", jsonld = null, og = null, robots = null }) {
  useEffect(() => {
    if (title) document.title = title;
    const rmeta = document.querySelector('meta[name="robots"]');
    if (rmeta) rmeta.setAttribute("content", robots || "index, follow, max-image-preview:large, max-snippet:-1");
    if (description) {
      let meta = document.querySelector('meta[name="description"]');
      if (meta) meta.setAttribute("content", description);
    }
    const origin = window.location.origin;
    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = origin + canonicalPath;

    const ogMap = og || {};
    const created = [];
    const setOg = (prop, content) => {
      if (!content) return;
      let tag = document.querySelector(`meta[property="${prop}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.setAttribute("property", prop);
        document.head.appendChild(tag);
      }
      tag.setAttribute("content", content);
    };
    if (title) setOg("og:title", title);
    if (description) setOg("og:description", description);
    setOg("og:url", origin + canonicalPath);
    setOg("og:type", ogMap.type || "website");
    if (ogMap.image) {
      setOg("og:image", ogMap.image);
      setOg("twitter:card", "summary_large_image");
      let tw = document.querySelector('meta[name="twitter:image"]');
      if (!tw) {
        tw = document.createElement("meta");
        tw.name = "twitter:image";
        document.head.appendChild(tw);
      }
      tw.setAttribute("content", ogMap.image);
    }

    let ldEl = null;
    const ldId = `seo-ld-${++ldCounter}`;
    if (jsonld) {
      ldEl = document.createElement("script");
      ldEl.type = "application/ld+json";
      ldEl.id = ldId;
      ldEl.text = JSON.stringify(jsonld);
      document.head.appendChild(ldEl);
    }
    return () => {
      if (ldEl) document.getElementById(ldId)?.remove();
    };
  }, [title, description, canonicalPath]);
  return null;
}
